import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import jwtDecode from 'jwt-decode';
import { mapActions } from 'vuex';
import { isValidToken } from '~/helpers/connection-helper';
import { convertInMinutes, calculateDifferenceInMinutes } from '~/helpers/refresh-auth-helper';
import USE_MERCURE from '~/const/mercure';
import { updateUserToken, refreshToken } from '~/services/user';
var HOURS_TOKEN_MUST_BE_REFRESHED = 2;
var HOURS_TOKEN_IS_VALID = 24;
var HOURS_TOKEN_NEEDS_REFRESH = HOURS_TOKEN_IS_VALID - HOURS_TOKEN_MUST_BE_REFRESHED; // @TODO remove

var styles = ['background: linear-gradient(#D33106, #571402)', 'color: white', 'font-weight: bold', 'padding: 10px'].join(';');
export default {
  data() {
    return {
      source: 'MERCURE',
      ready: true
    };
  },

  created() {
    if (this.$route.name === 'market-language-cart') {
      this.ready = false;
    }
  },

  mounted() {
    var _this = this;

    return _asyncToGenerator(function* () {
      yield _this.initRefreshUserToken();
    })();
  },

  computed: {
    decodedToken() {
      return jwtDecode(window.localStorage.getItem('MDM_ACCESS_TOKEN'));
    },

    audience() {
      var {
        aud
      } = this.decodedToken;
      return Array.isArray(aud) && aud.includes('sts') ? 'sts' : aud;
    },

    isMercureToken() {
      return this.audience === 'mercure';
    },

    isStsToken() {
      return this.audience === 'sts';
    },

    isMercureMarket() {
      return USE_MERCURE(this.locale.iso);
    },

    isSeller() {
      return this.$cookies.get('MDM_SELLER_TOKEN');
    },

    canRenewMercureToken() {
      return isValidToken() && !this.isSeller && this.isMercureMarket && this.isMercureToken && this.isTokenAlmostExpired;
    },

    canRefreshStsToken() {
      return !this.isSeller && this.isStsToken && this.isMercureMarket && this.isTokenAlmostExpired;
    },

    isTokenAlmostExpired() {
      var decoded = this.decodedToken;
      var tokenExpiresAt = Number(decoded.exp * 1000);
      var currentTimestamp = new Date().getTime();
      var differenceInMinute = calculateDifferenceInMinutes(tokenExpiresAt, currentTimestamp);
      var minutesBeforeExpiry = Math.sign(differenceInMinute) === 1 ? differenceInMinute : 0; // return minutesBeforeExpiry <= convertInMinutes(HOURS_TOKEN_NEEDS_REFRESH);

      var expiryThreshold = this.$cookies.get('refreshTokenThreshold') || convertInMinutes(HOURS_TOKEN_NEEDS_REFRESH); // @TODO remove

      var debugSts = !!this.$cookies.get('debugSts');

      if (debugSts) {
        console.log('%c Token status', styles);
        console.table({
          'cookie refreshTokenThreshold': this.$cookies.get('refreshTokenThreshold'),
          audience: Array.isArray(decoded.aud) ? decoded.aud.join(', ') : decoded.aud,
          expiryThreshold,
          minutesBeforeExpiry,
          expireAt: new Date(decoded.exp * 1000),
          isTokenAlmostExpired: minutesBeforeExpiry <= expiryThreshold
        });
      }

      return minutesBeforeExpiry <= expiryThreshold;
    }

  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    setSeller: 'seller/setSeller'
  })), {}, {
    initRefreshUserToken() {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        if (_this2.$route.name === 'redirect_url') {
          return;
        }

        if (window.localStorage.getItem('MDM_ACCESS_TOKEN') && _this2.canRenewMercureToken) {
          yield _this2.renewCustomerToken();
        } else if (window.localStorage.getItem('MDM_ACCESS_TOKEN') && _this2.isMercureToken && !isValidToken()) {
          // delete expiry Mercure accessToken
          window.localStorage.removeItem('MDM_ACCESS_TOKEN');
          window.localStorage.removeItem('MDM_ACCESS_TOKEN_EXPIRES_AT');
        }

        if (_this2.isSeller) {
          var seller = jwtDecode(_this2.$cookies.get('MDM_SELLER_TOKEN'));

          _this2.setSeller(seller);
        }

        if (window.localStorage.getItem('MDM_ACCESS_TOKEN') && _this2.canRefreshStsToken) {
          _this2.source = 'STS';
          yield _this2.renewCustomerToken();
        }

        _this2.ready = true;
      })();
    },

    setCustomerToken(token) {
      var decoded = jwtDecode(token);
      window.localStorage.setItem('MDM_ACCESS_TOKEN', token);
      window.localStorage.setItem('MDM_ACCESS_TOKEN_EXPIRES_AT', decoded.exp * 1000);
    },

    renewCustomerToken() {
      var _this3 = this;

      return _asyncToGenerator(function* () {
        try {
          var data = null;
          var token = null;

          if (_this3.source === 'STS') {
            data = yield refreshToken(_this3.$store);
            token = data && data.refreshToken && data.refreshToken.token;
          } else {
            data = yield updateUserToken(_this3.$store);
            token = data && data.updateUserToken && data.updateUserToken.token;
          } // @TODO remove


          var debugSts = !!_this3.$cookies.get('debugSts');

          if (debugSts) {
            console.log("%c refreshToken ".concat(_this3.source), styles);
            console.log(token);
          }

          if (!token) {
            throw new Error("MDM_REFRESH_TOKEN_EMPTY ".concat(_this3.source));
          }

          yield _this3.setCustomerToken(token);

          _this3.loadUser(); // page need to be refresh

        } catch (error) {
          _this3.$logger.customFilter(error, "MDM_REFRESH_TOKEN ".concat(_this3.source));
        }
      })();
    }

  })
};